import { ComponentProps, type FC } from 'react';

import { Divider, Skeleton } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

type Props = ComponentProps<'div'>;

const StatusBarSkeleton: FC<Props> = (props) => {
  return (
    <div
      {...props}
      className={cn(
        'flex w-full max-w-67 items-center gap-1.5',
        props.className,
      )}
    >
      <Skeleton variant="rounded" className="h-4 shrink-0 grow-0 basis-21" />
      <div className="h-6">
        <Divider orientation="vertical" />
      </div>
      <Skeleton variant="rounded" className="h-8 grow" />
    </div>
  );
};

export default StatusBarSkeleton;
